/**
* DevExpress Dashboard (_layout-options.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { LayoutDimensionOptions } from '../layout-dimension-options';
import { heightOptionsSerializationInfo, widthOptionsSerializationInfo } from './_layout-dimension-options';
let heightSerializationInfo = { propertyName: 'height', modelName: 'Height', type: LayoutDimensionOptions, info: heightOptionsSerializationInfo };
let widthSerializationInfo = { propertyName: 'width', modelName: 'Width', type: LayoutDimensionOptions, info: widthOptionsSerializationInfo };
export let layoutOptionsSerializationInfo = [heightSerializationInfo, widthSerializationInfo];
